import { compose, createStore, combineReducers, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";

import {reducer as userReducer, State as UserState} from "./user/reducer";

export type ActionDispatch = any;

export type RootState = {
  user: UserState;
};

const reducer = combineReducers<RootState>({
  user: userReducer,
});

declare const DEVELOPMENT: boolean;

let middleware;

if (DEVELOPMENT) {
  const composeEnhancers =
    (typeof window === "object" && window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]) ?
    window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({}) :
    compose;

  middleware = composeEnhancers(
    applyMiddleware(thunkMiddleware)
  );
}
else {
  middleware = applyMiddleware(thunkMiddleware);
}

export const store = createStore(reducer, middleware);



// WEBPACK FOOTER //
// ./src/reducers/index.ts